import type { ReactNode } from "react";
import { AuthProvider } from "@/auth";
import { I18nProvider, type Locale } from "@/i18n";
import { CartProvider } from "@/lib/cart-context";

export function AppProviders({
  children,
  initialLocale,
  deferStoredSession = false,
}: {
  children: ReactNode;
  initialLocale?: Locale;
  deferStoredSession?: boolean;
}) {
  return <I18nProvider initialLocale={initialLocale}>
    <AuthProvider deferStoredSession={deferStoredSession}>
      <CartProvider>{children}</CartProvider>
    </AuthProvider>
  </I18nProvider>;
}
